import React, { useEffect, useState } from "react";
import classNames from "classnames";
// import { ReactComponent as Arrow } from "../../assets/icons/Arrow.svg";
import Arrow from '../../assets/icons/iconDropdown.svg'
import IconDropDown from "../icons/iconDropDown";
const Pagination = ({ currentPage, pageSize, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  const [maxPage, setMaxPage]=useState(Math.ceil(totalCount/pageSize))

useEffect(()=>{
    setMaxPage(Math.ceil(totalCount/pageSize))

  },[pageSize])

  if (totalPages === 1) return null;

  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }
  const getPageNumbers = () => {
    const minPage = Math.max(1, currentPage - 2);
    const maxPage = Math.min(totalPages, currentPage + 2);

    const pageNumbers = [];

    for (let i = minPage; i <= maxPage; i++) {
      if (i !== 1 && i !== totalPages) pageNumbers.push(i);
    }

    return pageNumbers;
  };

  
  const pageNumbers = getPageNumbers();


  return (
    <nav className="flex gap-5">
      <button className={ `${currentPage > 1 ? 'border-[#AEB6FB]  ' : 'border-[#D1D1FF] cursor-default ' } rounded-[4px] border w-[24px] h-[24px] flex items-center justify-center `}
      onClick={()=>
        {
          if(currentPage >1)
            onPageChange(currentPage-1)
        }
      }
      >
        <IconDropDown className={` ${currentPage > 1 ? 'text-[#AEB6FB]  ' : 'text-[#D1D1FF] cursor-default '}  rotate-90 h-[20px] w-auto`}/>
      </button>
      <div className="text-[#AEB6FB]"> Page {currentPage < 10 && '0'}{currentPage} of {maxPage} </div>

      <button className={` ${currentPage < totalPages ? 'border-[#AEB6FB] cursor-pointer ' : 'border-[#D1D1FF]  cursor-default ' } rounded-[4px] border  w-[24px] h-[24px] flex items-center justify-center`}
      onClick={()=>{
        if(currentPage < totalPages)
        onPageChange(currentPage+1)
        }
      }
      >
        <IconDropDown className={` ${currentPage < totalPages ? 'text-[#AEB6FB]  ' : 'text-[#D1D1FF] cursor-default '}  -rotate-90 h-[20px] w-auto`}/>

      </button>
    </nav>
  );
};

export default Pagination;
